import { gql } from "@apollo/client";

export const CREATE_CHECKOUT_SESSION = gql`
  mutation (
    $successUrl: String!
    $cancelUrl: String!
    $stripePriceId: String!
  ) {
    createCheckoutSession(
      successUrl: $successUrl
      cancelUrl: $cancelUrl
      stripePriceId: $stripePriceId
    ) {
      sessionId
      sessionUrl
    }
  }
`;
